export default "__VITE_ASSET__56bde489__"